// version 1

//auth
export const API_LOGIN = "/v1/Account/authenticate";
export const API_GET_TWOFADETAILS = "/v1/Account/getTwoFAdetails";
export const API_POST_ACTIVEDEACTIVE2FA = "/v1/Account/activeDeactive2FA";
export const API_POST_VERIFYLOGIN2FA = "/v1/Account/verifyLogin2Fa";
export const API_POST_CHANGEPASSWORD = "/v1/Account/changePassword";
export const API_POST_USERLIST = "/v1/Account/userList";
export const API_POST_GETROLES = "/v1/Account/getRoles";
export const API_POST_CREATEUPDATEUSER = "/v1/Account/upsertUser";
export const API_POST_LOGINHISTORY = "/v1/Account/LoginHistory";
export const API_POST_USERPAGES = "/v1/Account/UserPages";
export const API_POST_SYNCPAGES = "/v1/Account/syncPages";

// Report
export const API_GET_SERVERS = "/v1/Report/getServers";
export const API_POST_TRADELIST = "/v1/Report/tradeList";
export const API_POST_POSITION = "/v1/Report/Position";
export const API_POST_USERWISEPOSITION = "/v1/Report/userWisePosition";
export const API_POST_ANAlYSEDEVICES = "/v1/Report/AnalyseDevices";
export const API_POST_GETEXCHANGES = "/v1/Report/getExchanges";
export const API_POST_SCRIPTS = "/v1/Report/Scripts";
export const API_POST_SCRIPTWISEPOSITIONHISTORY =
  "/v1/Report/ScriptWisePositionHistory";
export const API_POST_USERWISEPOSITIONHISTORY =
  "/v1/Report/UserWisePositionHistory";
export const API_POST_USERLISTSERVER = "/v1/Report/UserListServerWise";
export const API_POST_TRADEREPORT = "/v1/Report/TradeReport";
export const API_POST_SCRIPTPLSUMMARY = "/v1/Report/ScriptWisePLSummary";
export const API_POST_TRADEANALYTICS = "/v1/Report/TradeAnalytics";
export const API_POST_FILTERORDER = "/v1/Report/FilterOrders";
export const API_POST_ANALYSELOGINDEVICE = "/v1/Report/AnalyseLoginWiseDevices";
export const API_POST_TRADELISTCUSTOM = "/v1/Report/UpsertServerOrderFlag";
export const API_POST_SCRIPTPOSITIONHISTORY =
  "/v1/Report/ScriptPositionHistory";
export const API_POST_SCRIPTMARKETWATCH = "/v1/Report/ScriptMarketWatch";
export const API_POST_TRAILINGORDER = "/v1/Report/TrailingOrders";

// -------------------------old apis-------------------------
export const API_AUTH_TOKEN = "/v1/user/createAuthToken";
export const API_CHECK_AUTH = "/v1/user/checkAuthToken";
export const API_LOGOUT = "/v1/user/logout";

// live market
export const API_LIVE_MARKET = "/v1/instruments/isBadlalist";

// badla
export const API_GET_BADLA_LIST = "/v1/badlainstruments/getBadlaInstrument";
export const API_GET_SCRIPTS = "/v1/userScript/getUserScript";
export const API_ADD_SCRIPTS = "/v1/userScript/addUserScript";
export const API_DELETE_SCRIPTS = "/v1/userScript/deleteUserScript";
export const API_UPDATE_SCRIPTS = "/v1/userScript/updateUserScript";
export const API_HISTORY_DAYWISE = "/v1/historySummary/getHistoryDayWise";
export const API_HISTORY_MINUTEWISE = "/v1/historySummary/getHistoryMinitely";

// badla order
export const API_BADLA_LAST_PRICE = "/v1/badlaOrder/getBadlaLastPrice";
export const API_BADLA_ORDER_ADD = "/v1/badlaOrder/add";
export const API_BADLA_ORDER_FETCH = "/v1/badlaOrder/get";

// version 2
export const API_POST_V2_FILTERORDER = "/v2/Report/FilterOrders";

// Ai
export const API_AI_TRADES = "/analyze/react-analyze";
